namespace SPA
{
	export namespace Realtor2
	{
		export namespace New
		{
			export class Final extends Guide.GuideContent
			{

				private m_Form: ui.Form.Form;

				public constructor(
					private	m_Data: IFinal,
					private	m_Company: Wollmilch.CompanyObject,
					private	m_Obj: NewObject

				)
				{
					super();

					this.m_Form = new ui.Form.Form(
						{
							action: '',
							method: 'POST',
							notSwitchable: true,
							submit: () => { return; }
						}
					);
				}

				public build( root: ui.base.BaseHTMLElement ): void
				{
					this.m_Form.empty();
					this.m_Form.remove();

					this.m_Form.rebuild( root );

					new ui.base.BaseHTMLElement( 'h4' )
						.addClass( 'text-muted' )
						.text( 'Abschließende Angaben' )
					.appendTo( this.m_Form );

					this.buildRow1( this.m_Form );

					//new ui.base.BaseHTMLElement( 'hr' ).appendTo( this.m_Form );

					this.buildRow2( this.m_Form );
				}

				protected buildNavigation( nav: ui.base.BaseHTMLElement ): void
				{
					new ui.base.Button(
						$('<i class="fas fa-arrow-circle-left"></i> <span>Zurück</span>'),
						{
							context: 'primary',
							on:
							{
								click: () =>
								{
									if ( this.m_Panel ) { this.m_Panel.MovePrev(); }
								}
							}
						}
					).rebuild( nav );

					// if (this.m_Obj.Mode === 'new')
					// {

					new ui.base.Button(
						$('<i class="fas fa-save"></i> <span>Objekt anlegen</span>'),
							{
								context: 'success',
								on:
								{
									click: () => {
										if ( this.m_Obj.checkForm( this.m_Form ) )
										{
											this.m_Obj.sendForm();
										}
									}
								}
							}
						).rebuild( nav );
					// }
				}

				private buildRow1( _root: ui.base.BaseHTMLElement ): void
				{
					const row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( _root );

					this.buildMoneys(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-6' )
						.appendTo( row )
					);

					this.buildAdditional(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-6' )
						.appendTo( row )
					);
				}

				private buildRow2( _root: ui.base.BaseHTMLElement ): void
				{
					const row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( _root );

					// this.buildOrders(
					// 	new ui.base.BaseHTMLElement( 'div' )
					// 		.addClass( 'col-xs-12 col-md-6' )
					// 	.appendTo( row )
					// );
				}

				private buildMoneys( _root: ui.base.BaseHTMLElement ): void
				{
					_root.empty();

					const _title: ui.Form.TextInput = new ui.Form.TextInput(
						this.m_Data.title,
						{
							control: true,
							noautocomplete: true,
							on:
							{
								change: () => this.m_Data.title = _title.val() || ''
							}
						}
					);
					const _price: ui.Form.TextInput = new ui.Form.TextInput(
						this.m_Data.price.value ? accounting.formatMoney(this.m_Data.price.value) : '',
						{
							classes: ['currency'],
							control: true,
							required: true,
							on:
							{
								change: () => this.m_Data.price.value = _price.val() ? accounting.unformat(_price.val() || '', ',') : 0
							}
						}
					);

					const _yearlyRent: ui.Form.TextInput = new ui.Form.TextInput(
						this.m_Data.yearlyRent && this.m_Data.yearlyRent.value ? accounting.formatMoney(this.m_Data.yearlyRent.value) : '',
						{
							control: true,
							classes: ['currency'],
							on:
								{
									change: () => this.m_Data.yearlyRent.value = _price.val() ? accounting.unformat(_yearlyRent.val() || '', ',') : 0
								}
						}
					);

					const _solemandate_from = new ui.Form.TextInput(null, {
						name: 'solemandate_from',
						control: true,
					});
					const _solemandate_until = new ui.Form.TextInput(null, {
						name: 'solemandate_until',
						control: true,
					});

					const _in_prov: ui.Form.NumberInput = new ui.Form.NumberInput(
						this.m_Data.fee.interior ? this.m_Data.fee.interior.value : null,
						{
							control: true,
							required: false,
							min: 0,
							step: 0.01,
							on:
							{
								change: () =>
								{
									const prov = _in_prov.val();
									const _type = this.m_Data.fee.interior ? this.m_Data.fee.interior.type : EProvision.ABSOLUTE;
									this.m_Data.fee.interior = {
										type: _type,
										value: prov || 0
									};
								}
							}
						},
						false
					);
					const _out_prov: ui.Form.NumberInput = new ui.Form.NumberInput(
						this.m_Data.fee.exterior ? this.m_Data.fee.exterior.value : null,
						{
							control: true,
							required: false,
							min: 0,
							step: 0.01,
							on:
							{
								change: () =>
								{
									const prov = _out_prov.val();
									const _type = this.m_Data.fee.exterior ? this.m_Data.fee.exterior.type : EProvision.RELATIVE;
									this.m_Data.fee.exterior = {
										type: _type,
										value: prov || 0
									};
								}
							}
						},
						false
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-8' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Objekttitel' )
									.addClass( 'control-label col-xs-12 col-md-4' )
								)
							.appendTo( _root )
						),
						this.m_Form,
						_title
					);

					const ig_price = new ui.base.BaseHTMLElement('div')
						.addClass('input-group')
					.appendTo(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-md-8')
						.appendTo(
							new ui.base.BaseHTMLElement('div')
								.addClass('form-group clearfix')
								.append(
									new ui.base.BaseHTMLElement('label')
										.text('Angebotspreis*')
										.addClass('control-label col-xs-12 col-md-4')
								)
								.appendTo(_root)
						)
					);

					this.addToForm(ig_price, this.m_Form, _price);

					new ui.base.BaseHTMLElement('span')
						.addClass('input-group-addon')
						.text('€')
						.appendTo(ig_price);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-md-8')
							.appendTo(
								new ui.base.BaseHTMLElement('div')
									.addClass('form-group clearfix')
									.append(
										new ui.base.BaseHTMLElement('label')
											.text('Jahresmiete')
											.addClass('control-label col-xs-12 col-md-4')
									)
									.appendTo(_root)
							),
						this.m_Form,
						_yearlyRent
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-md-5 col-lg-7')
							.appendTo(
								new ui.base.BaseHTMLElement('div')
									.addClass('form-group clearfix')
									.append(
										new ui.base.BaseHTMLElement('label')
											.text('Alleinvertretungsmandat von')
											.addClass('control-label col-xs-12 col-md-7 col-lg-5')
									)
									.appendTo(_root)
							),
						this.m_Form,
						_solemandate_from
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-md-5 col-lg-7')
							.appendTo(
								new ui.base.BaseHTMLElement('div')
									.addClass('form-group clearfix')
									.append(
										new ui.base.BaseHTMLElement('label')
											.text('Alleinvertretungsmandat bis')
											.addClass('control-label col-xs-12 col-md-7 col-lg-5')
									)
									.appendTo(_root)
							),
						this.m_Form,
						_solemandate_until
					);

					const _out_prov_grp: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'input-group' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-8' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Außen-Provision' )
									.addClass( 'control-label col-xs-12 col-md-4' )
								)
							.appendTo( _root )
						)
					);

					const _in_prov_grp: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'input-group' )
					.appendTo(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-8' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Innen-Provision' )
									.addClass( 'control-label col-xs-12 col-md-4' )
								)
							.appendTo( _root )
						)
					);

					const _out_prov_type_sym: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'span' )
					.text( this.m_Data.fee.exterior && this.m_Data.fee.exterior.type === EProvision.ABSOLUTE ? '€' : '%' );
					const _in_prov_type_sym: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'span' )
					.text( this.m_Data.fee.interior && this.m_Data.fee.interior.type === EProvision.RELATIVE ? '%' : '€' );

					const _in_prov_type: ui.Form.Select = new ui.Form.Select(
						{
							control: false,
							required: true,
							on:
							{
								change: () =>
								{
									const prov = _in_prov_type.val();
									if ( prov === null )
									{
										this.m_Data.fee.interior = null;
									}
									else
									{
										const val = this.m_Data.fee.interior ? this.m_Data.fee.interior.value : null;

										this.m_Data.fee.interior = {
											type: prov === 'ABSOLUTE' ? EProvision.ABSOLUTE : EProvision.RELATIVE,
											value: val || 0
										};

										_out_prov_type_sym.text( prov && prov === 'RELATIVE' ? '%' : '€' );

										this.buildMoneys( _root );
									}
								}
							},
							option:
							{
								ABSOLUTE: 'Pauschal',
								RELATIVE: 'Prozentual'
							}
						},
						(this.m_Data.fee.interior ? this.m_Data.fee.interior.type : EProvision.ABSOLUTE).toString()
					);
					const _out_prov_type: ui.Form.Select = new ui.Form.Select(
						{
							control: false,
							required: true,
							on:
							{
								change: () =>
								{
									const prov = _in_prov_type.val();
									if ( prov === null )
									{
										this.m_Data.fee.exterior = null;
									}
									else
									{
										const val = this.m_Data.fee.exterior ? this.m_Data.fee.exterior.value : null;

										this.m_Data.fee.exterior = {
											type: prov === 'ABSOLUTE' ? EProvision.ABSOLUTE : EProvision.RELATIVE,
											value: val || 0
										};
										_out_prov_type_sym.text( prov && prov === 'ABSOLUTE' ? '€' : '%' );

										this.buildMoneys( _root );
									}
								}
							},
							option:
							{
								ABSOLUTE: 'Pauschal',
								RELATIVE: 'Prozentual'
							}
						},
						(this.m_Data.fee.exterior ? this.m_Data.fee.exterior.type : EProvision.RELATIVE).toString()
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'span' )
							.addClass( 'input-group-addon' )
						.appendTo( _out_prov_grp ),
						this.m_Form,
						_out_prov_type
					);
					this.addToForm(
						new ui.base.BaseHTMLElement( 'span' )
							.addClass( 'input-group-addon' )
						.appendTo( _in_prov_grp ),
						this.m_Form,
						_in_prov_type
					);

					this.addToForm( _out_prov_grp, this.m_Form, _out_prov );
					this.addToForm( _in_prov_grp, this.m_Form, _in_prov );

					_out_prov_type_sym.appendTo(
						new ui.base.BaseHTMLElement( 'span' )
							.addClass( 'input-group-addon' )
						.appendTo( _out_prov_grp )
					);

					_in_prov_type_sym.appendTo(
						new ui.base.BaseHTMLElement( 'span' )
							.addClass( 'input-group-addon' )
						.appendTo( _in_prov_grp )
					);
				}

				private buildOrders( _root: ui.base.BaseHTMLElement ): void
				{
					_root.empty();

					new ui.base.BaseHTMLElement( 'h4' )
						.addClass( 'text-muted' )
						.text( 'Karten- und Dokumentenbestellungen' )
					.appendTo( _root );

					{
						const lrm = new ui.Form.Checkbox(
							{
								title: 'Liegenschaftskarte anfordern',
								descriptor:
								{
									on:
									{
										change: () =>
										{
											this.m_Obj.setLRM( lrm.val() );
										}
									}
								}
							}
						);
						const dtpackage = new ui.Form.Checkbox(
							{
								title: 'Datenpaket anfordern',
								descriptor:
								{
									on:
									{
										change: () =>
										{
											this.m_Obj.setDataPackage( dtpackage.val() );
										}
									}
								}
							}
						);
						const registerFile = new ui.Form.FileInput(
							{
								accept: [
									'application/pdf'
								],
								control: true,
								placeholder: 'Bitte Vollmacht hochladen',
								fileChange: ( files: FileList ) =>
								{
									const fr = new FileReader();

									fr.onloadend = () =>
									{
										if ( fr.result === null )
										{
											return;
										}

										this.m_Obj.setRegister(
											{
												order: true,
												file:
												{
													name: files[ 0 ].name,
													data: fr.result.toString().split( ',' )[ 1 ],
													mime: files[ 0 ].type + ';base64',
													length: files[ 0 ].size
												}
											}
										);
									};

									fr.readAsDataURL( files[ 0 ] );

									return;
								}
							}
						);
						registerFile.attr( 'disabled', !this.m_Obj.getRegister().order );
						const easementFile = new ui.Form.FileInput(
							{
								accept: [
									'application/pdf'
								],
								control: true,
								placeholder: 'Bitte Vollmacht hochladen',
								fileChange: ( files: FileList ) =>
								{
									const file = files[ 0 ];
									const fr = new FileReader();

									fr.onloadend = () =>
									{
										if ( fr.result === null )
										{
											return;
										}

										this.m_Obj.setEasement(
											{
												order: true,
												file:
												{
													name: file.name,
													data: fr.result.toString().split( ',' )[ 1 ],
													mime: files[ 0 ].type + ';base64',
													length: file.size
												}
											}
										);
									};

									fr.readAsDataURL( file );

									return;
								}
							}
						);
						easementFile.attr( 'disabled', !this.m_Obj.getEasement().order );
						const register = new ui.Form.Checkbox(
							{
								title: 'Grundbuchauszug anfordern',
								descriptor:
								{
									on:
									{
										change: () =>
										{
											this.m_Obj.setRegister( { order: register.val(), file: null } );

											if ( register.val() )
											{
												registerFile.attr( 'disabled', false );
											}
											else
											{
												registerFile.attr( 'disabled', true );
												registerFile.reset();
											}
										}
									}
								}
							}
						);
						register.value( this.m_Obj.getRegister().order );
						const easement = new ui.Form.Checkbox(
							{
								title: 'Baulastenverzeichnis anfordern',
								descriptor:
								{
									on:
									{
										change: () =>
										{
											this.m_Obj.setEasement( { order: easement.val(), file: null } );

											if ( easement.val() )
											{
												easementFile.attr( 'disabled', false );
											}
											else
											{
												easementFile.attr( 'disabled', true );
												easementFile.reset();
											}
										}
									}
								}
							}
						);

						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-11 col-xs-offset-1' )
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'form-group clearfix' )
								.appendTo( _root )
							),
							this.m_Form,
							lrm
						);

						const registerDIV = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'form-group clearfix' )
						.appendTo( _root );
						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-4 col-xs-offset-1' )
							.appendTo( registerDIV ),
							this.m_Form,
							register
						);
						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-7' )
							.appendTo( registerDIV ),
							this.m_Form,
							registerFile
						);

						const easementDIV = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'form-group clearfix' )
						.appendTo( _root );
						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-4 col-xs-offset-1' )
							.appendTo( easementDIV ),
							this.m_Form,
							easement
						);
						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-7' )
							.appendTo( easementDIV ),
							this.m_Form,
							easementFile
						);

						this.addToForm(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-11 col-xs-offset-1' )
							.appendTo(
								new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'form-group clearfix' )
								.appendTo( _root )
							),
							this.m_Form,
							dtpackage
						);
					}
				}

				private buildAdditional( _root: ui.base.BaseHTMLElement ): void
				{
					_root.empty();

					const ref = new ui.Form.TextInput(
						this.m_Data.ref,
						{
							on:
							{
								change: () =>
								{
									this.m_Data.ref = ref.val() || '';
								}
							},
							control: true
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-8' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Eigene Objekt-ID' )
									.addClass( 'control-label col-xs-12 col-md-4' )
								)
							.appendTo( _root )
						),
						this.m_Form,
						ref
					);

					const int_ann = new ui.Form.TextArea(
						{
							text: this.m_Data.annotation,
							on:
							{
								change: () =>
								{
									this.m_Data.annotation = int_ann.val() || '';
								}
							},
							css:
							{
								resize: 'vertical'
							},
							control: true
						}
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-md-8' )
						.appendTo(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'form-group clearfix' )
								.append(
									new ui.base.BaseHTMLElement( 'label' )
										.text( 'Interne Bemerkung' )
									.addClass( 'control-label col-xs-12 col-md-4' )
								)
							.appendTo( _root )
						),
						this.m_Form,
						int_ann
					);
				}

			}
		}
	}
}
